import React from 'react';
import './OrderComponent.scss';
import {getShareList, getUserRankInfo, openReward} from "../../asstes/js/Rescource";
import {
	analysisSubmit,
	clearUserInfo,
	createShareUrl,
	getUserOrderList, historyOfPush, showPassWordModules,
	showToast,
} from "../../asstes/js/IntegratedProcessing";
import {isInWeChat, showLogin} from "../../asstes/js/Utils";
import Api from "../../asstes/js/Api";
import dayjs from 'dayjs'
import history from "../../router/history";
import ShareAlertModule from "../ShareAlertModule/ShareAlertModule";
import ShareOtherComponent from "../ShareOtherComponent/ShareOtherComponent";
import RankListComponent from "./RankListComponent";

class OrderComponent extends React.Component {
	state = {
		top: window.scrollY,
		status: 'reward', // reward rank
		orderList: [],
		rankList: [],
		recordCount: 0, // 总的分页页数
		userInfo: {
			bocIntegration: 0,
			ranking: 0,
			wxRedBag: 0
		},
		myInfoImg: false,
		bgInit: false,
		showShareModules: false, // 打开分享的大弹窗-分享海报|分享微信提示
		createPostUrl: null, // 生成海报的url
		onlyBocApp: false, // 仅展示中行APP分享
		cashValue: null, // 海豹金额
		loginUserInfo: null, // 排行榜的用户信息
	}

	UNSAFE_componentWillMount() {
		let bodyEl = document.body
		setTimeout(() => {
			bodyEl.style.position = 'fixed'
			bodyEl.style.top = -this.state.top + 'px'
		}, 200)
		this.getTypeData()
	}

	componentWillUnmount() {
		let bodyEl = document.body
		bodyEl.style.position = ''
		bodyEl.style.top = ''
		window.scrollTo(0, this.state.top) // 回到原先的top
	}

	changeStatus(status) {
		this.setState({
			status: status,
			cashValue: null,
			rankList: [],
			loginUserInfo: null
		}, () => this.getTypeData())
	}

	// 根据不同类型请求不同接口
	getTypeData = (type = '') => {
		let {status} = this.state
		if (status === 'rank') { // 排行榜
			this.getShareListData()
		} else {
			this.getUserRankInfo()
			this.getOrderListData()
		}
	}

	getUserRankInfo = () => {
		getUserRankInfo().then(res => {
			if (res.success) {
				this.setState({
					userInfo: Object.assign(this.state.userInfo, res.datas),
					cashValue: String(parseFloat(res.datas.wxRedBag))
				})
			} else if (res.errorCode === '410015') {
				this.close()
				clearUserInfo()
				showLogin()
			}
		})
	}

	getOrderListData = () => {
		let orderList = []
		getUserOrderList({
			state: '',
			pageSize: '100'
		}).then(res => {
			if (res.code === '200') {
				orderList = res.arr
				if (orderList.length > 0) {
					orderList = orderList.filter(item => {
						let state = item.state
						if (Api.isLan) { // 测试环境
							return (state === '0' || state === '1' || state === '2' || state === '-1')
						} else {
							return (state === '0' || state === '1' || state === '2' || state === '-1')
						}
					})
				}
				if (orderList.length === 0) {
					orderList.push({updateTime: '', rdetailName: ''})
				}
				this.setState({
					orderList: orderList
				}, () => {
					// if (type === 'reload') return;
					// let userPayReward = orderList.filter(item => item.state === '0')
					// let userShareReward = orderList.filter(item => item.state === '-1')
					// if (userPayReward.length === 0 && userShareReward.length === 0) return
					// userSelectArrReceive(this, userPayReward, userShareReward)
				})
			} else if (res.code === '500') {
				showToast('服务器异常，请稍后重试!')
			} else {
				showToast('获取数据异常，请稍后重试')
			}
		})
	}

	// 获取排行榜数据
	getShareListData = (pageNo = 1) => {
		let {recordCount} = this.state
		if (recordCount < pageNo && pageNo !== 1) {
			return
		}
		/* let arr3 = [
			{userCode: '136****3739', score: '19'},
			{userCode: '136****3739', score: '18'},
			{userCode: '136****3739', score: '17'},
		]
		let arr2 = [
			{userCode: '136****3739', score: '17'},
			{userCode: '136****3739', score: '16'},
			{userCode: '136****3739', score: '15'},
			{userCode: '136****3739', score: '14'},
			{userCode: '136****3739', score: '13'},
			{userCode: '136****3739', score: '12'},
			{userCode: '136****3739', score: '11'},
			{userCode: '136****3739', score: '10'},
			{userCode: '136****3739', score: '9'},
		]
		let arr1 = [
			{userCode: '136****3739', score: '9'},
			{userCode: '136****3739', score: '8'},
			{userCode: '136****3739', score: '7'},
			{userCode: '136****3739', score: '6'},
			{userCode: '136****3739', score: '5'},
			{userCode: '136****3739', score: '4'},
			{userCode: '136****3739', score: '3'},
			{userCode: '136****3739', score: '2'},
			{userCode: '136****3739', score: '1'},
		] */
		// console.log(pageNo);
		getShareList({
			pageNo: pageNo
		}).then(res => {
			if (res.success) {
				let rankList = res.datas.rankingLists
				// ====
				/* res.recordCount = 20
				if (pageNo === 1) {
					rankList = arr1
				} else if (pageNo === 2) {
					rankList = arr2
				} else if (pageNo === 3) {
					rankList = arr3
				} */
				// ====
				if (rankList.length === 0) {
					rankList.push({
						userCode: '',
						score: ''
					})
				}
				rankList = this.state.rankList.concat(rankList)
				this.setState({
					loginUserInfo: res.datas.rankingDetail,
					rankList: rankList,
					recordCount: Math.ceil(res.recordCount / 200)
				})
			} else {
				showToast('服务器异常，请稍后重试!')
			}
		}).catch(() => {
			showToast('服务器异常，请稍后重试!')
		})
		// userCode score
	}

	linkReward = () => {
		if (history.location.pathname === '/reward') {
			window.location.reload()
			return
		}
		historyOfPush('/reward')
	}

	close = (e) => {
		e && e.preventDefault()
		this.props.toggleOrder && this.props.toggleOrder(false)
	}

	share = () => {
		this.setState({
			showShareModules: true
		})
	}

	myInfoImg = () => {
		this.setState({
			myInfoImg: true
		})
	}

	bgInit = () => {
		this.setState({
			bgInit: true
		})
	}

	linkReceive = (item) => {
		if (item.state === '0') { // 去待领奖页面
			if (!isInWeChat() && item.rdefType === 'PRODUCT') {
				showToast('您有待领取的礼品，赶紧领取吧', 3000)
				this.setState({
					showShareModules: true,
					onlyBocApp: true
				})
				return;
			}
			if (history.location.pathname === '/reward') {
				window.location.reload()
				return
			}
			historyOfPush('/reward')
		} else { // 是发货失败 再次去领奖
			if (!isInWeChat() && item.rdefType === 'PRODUCT') {
				showToast('您有待领取的礼品，赶紧领取吧', 3000)
				this.setState({
					showShareModules: true,
					onlyBocApp: true
				})
				return;
			}
			openReward({
				sendNo: item.sendNo
			}).then(res => {
				if (res.success) { // 领奖成功
					showToast('领奖成功！')
					this.getOrderListData()
					analysisSubmit('openPrize')
				} else {
					showToast('发货失败请稍后重试，如您已重试还不成功，请联系客服处理。')
				}
			}).catch(() => {
				showToast('服务器异常，请稍后重试！')
			})
		}
	}

	createPost = () => {
		let {defaultLink} = createShareUrl()
		this.setState({
			createPostUrl: defaultLink
		})
	}

	hideShareModule = () => {
		this.setState({
			showShareModules: false,
			onlyBocApp: false
		})
	}

	hidePost = () => {
		this.setState({
			createPostUrl: ''
		})
	}

	getRankList = (idx) => {
		this.getShareListData(idx)
	}

	showBeansModule = () => {
		showPassWordModules('beans')
	}

	linkIndex = () => {
		if (history.location.pathname === '/index') {
			this.close()
			return
		}
		historyOfPush('/index')
	}

	render() {
		const loginBg = require('../../asstes/img/order/order-info-bg.png')
		const PayClose = require('../../asstes/img/alert/login-close.png')
		const orderBg = require('../../asstes/img/order/order-bg.png')
		const rewardIcon = require('../../asstes/img/order/my-reward.png')
		const rewardActive = require('../../asstes/img/order/my-reward-active.png')
		const rankIcon = require('../../asstes/img/order/rank.png')
		const rankActive = require('../../asstes/img/order/rank-active.png')
		const btn = require('../../asstes/img/order/share-order-btn.png')
		const flauntBtn = require('../../asstes/img/order/flaunt-order-btn.png')
		const myInfoBg = require('../../asstes/img/order/order-user-bg.png')
		const {status, orderList, rankList, recordCount, userInfo, myInfoImg, bgInit, showShareModules, createPostUrl, cashValue, onlyBocApp, loginUserInfo} = this.state

		const isReward = status === 'reward'

		function filterText(rdefType) {
			if (rdefType === 'PRODUCT') {
				return '元微信红包'
			} else {
				return '中银豆积分'
			}
		}


		let initStyle = isReward ? {
			margin: '2% auto 5%'
		} : {margin: '5% auto'}

		const myInfoStyle = isReward ? {
			margin: '5% auto 0',
		} : {
			margin: '',
			width: '0',
			height: '0',
			fontSize: '0 !important'
		}

		function changeTime(item) {
			if (item.updateTime) {
				return (item.updateTime).slice(5, 10)
			} else if (item.createTimeStamp) {
				return dayjs(item.createTimeStamp).format('MM-DD')
			} else {
				return '---'
			}
		}

		return <div className="order-container">
			<p className="prompt"></p>
			<div className="order-relative">
				<img src={loginBg} onLoad={this.bgInit} alt=""/>
				{
					bgInit ?
						<>
							<div className="order-relative-ctx flex-center-center">
								<div className="header-order flex-center-center">
									<img onClick={() => this.changeStatus('reward')} src={status === 'reward' ? rewardActive : rewardIcon}
									     alt=""/>
									<img onClick={() => this.changeStatus('rank')} src={status === 'reward' ? rankIcon : rankActive}
									     alt=""/>
								</div>
								<div className="relative" style={myInfoStyle}>
									<img className="my-info-bg" src={myInfoBg} onLoad={this.myInfoImg} alt=""/>
									{
										isReward && myInfoImg ? <div className="my-order-ctx flex-center-center">
											<div className="my-order-item">
												<p>{userInfo.wxRedBag ? parseFloat(userInfo.wxRedBag) : userInfo.wxRedBag}</p>
												<p className="order-title">红包(元)</p>
											</div>
											<div className="my-order-item" onClick={this.showBeansModule}>
												<p>{userInfo.bocIntegration}</p>
												<p className="order-title line">
													<span>中银豆积分</span>
												</p>
											</div>
											<div className="my-order-item">
												<p>{userInfo.ranking}</p>
												<p className="order-title">送出祝福</p>
											</div>
										</div> : null
									}
								</div>
								<div className="relative" style={initStyle}>
									<img className={`order-bg ${isReward ? 'my-order-bg' : ''}`} src={orderBg} alt=""/>
									<div className="order-absolute-content">
										{
											myInfoImg ?
												// 我的中奖纪录
												(isReward ? <div className="my-reward-list">
														{
															orderList.map((item, idx) => {
																return <div
																	className={`my-reward-list-item flex-between-center ${isReward ? 'my-reward-list-min' : ''}`}
																	key={idx}>
																	{
																		(!item.updateTime && !item.rdetailName) ?
																			<div className="my-reward-left flex-center-center"
																			     style={{width: '100%', padding: '0'}}>
																				<span className="no-reward-line" onClick={() => this.linkIndex()}>先拆开锦盒再来看您的礼品吧~</span>
																			</div> :
																			<>
																				<div
																					className="my-reward-left flex-center-center">{changeTime(item)}</div>
																				<div
																					className="my-reward-right flex-between-center">
																					{(item.rdetailName) + filterText(item.rdefType)}
																					{
																						(item.state === '0' || item.state === '-1') ?
																							<span className="my-receive-btn flex-center-center"
																							      onClick={() => this.linkReceive(item)}>领取</span> : <span>已领取</span>
																					}
																				</div>
																			</>
																	}
																</div>
															})
														}
													</div> :
													// 分享排行榜
													<RankListComponent recordCount={recordCount} rankList={rankList}
													                   loginUserInfo={loginUserInfo}
													                   getRankList={this.getRankList}/>) : null
										}
									</div>
								</div>
								<div className="order-btn">
									{
										isReward ?
											<img src={flauntBtn} onClick={this.share} alt=""/> :
											<img src={btn} onClick={this.share} alt=""/>
									}
								</div>
							</div>
							<img className="bottom-login-close-icon" src={PayClose} alt="" onClick={this.close}/>
						</> : null
				}
			</div>
			{ // 生成海报
				createPostUrl ? <ShareOtherComponent createPostUrl={createPostUrl} cashValue={cashValue} hidePost={this.hidePost}/> : null
			}
			{ // 生成分享弹窗
				showShareModules ? <ShareAlertModule createPost={this.createPost}
				                                     hideShareModule={this.hideShareModule}
				                                     onlyBocApp={onlyBocApp}
				                                     userCheckIn={orderList && orderList.length > 0 && orderList[0].rdetailName}/> : null
			}
		</div>
	}
}

export default OrderComponent;
